import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useStore } from "../../context/StoreContext";

const MENU_ITEMS = [
  { label: "SHOP ALL", to: "/shop", large: true },
  { label: "STAPLES", to: "/shop?category=staples" },
  { label: "EXCLUSIVES", to: "/exclusives" },
  { label: "LIMITED", to: "/shop?tag=limited" },
  { label: "UPCYCLED", to: "/shop?tag=upcycled" },
  { label: "CUSTOM", to: "/shop?tag=custom" },
];

const SECONDARY = [
  { label: "ABOUT US", to: "/about", large: true },
  { label: "CONTACT US", to: "/contact" },
];

const SlideMenu = () => {
  const { menuOpen, setMenuOpen } = useStore();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search, setMenuOpen]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [menuOpen, setMenuOpen]);

  return (
    <div
      data-testid="slide-menu"
      className={`fixed left-0 right-0 top-0 z-[90] bg-charcoal text-cream transition-transform duration-500 ${
        menuOpen ? "translate-y-0" : "-translate-y-full"
      }`}
      style={{ borderBottomLeftRadius: "22px", borderBottomRightRadius: "22px" }}
      role="dialog"
      aria-modal="true"
      aria-hidden={!menuOpen}
    >
      <div className="pt-[88px] pb-10 px-6 md:px-12 max-w-[1440px] mx-auto">
        <ul className="flex flex-col items-center text-center gap-4 md:gap-5">
          {MENU_ITEMS.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                data-testid={`menu-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`font-display uppercase tracking-wide block transition-colors hover:text-dc-red ${
                  item.large
                    ? "text-4xl md:text-6xl leading-none"
                    : "text-2xl md:text-3xl"
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li className="w-24 border-t border-cream/30 my-3" />
          {SECONDARY.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                data-testid={`menu-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`font-display uppercase tracking-wide block transition-colors hover:text-dc-red ${
                  item.large
                    ? "text-4xl md:text-6xl leading-none"
                    : "text-2xl md:text-3xl"
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="mt-10 flex items-center justify-between font-mono text-[11px] uppercase tracking-widest opacity-70">
          <span>EST. 2025</span>
          <span>DAMAGING THE CULTURE</span>
        </div>
      </div>
    </div>
  );
};

export default SlideMenu;
